"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _intl = require("@kyruus/intl");
var _print = _interopRequireDefault(require("./print"));
var _email = _interopRequireDefault(require("./email"));
var _facebook = _interopRequireDefault(require("./facebook"));
var _twitterX = _interopRequireDefault(require("./twitter-x"));
var _style = require("./style");
var _messages = _interopRequireDefault(require("./lib/messages"));
/**
 * Creates a click handler with a proxy event and event type
 * @param {function} handler the handler to execute
 * @param {string} eventType the event type to add to the data
 */
const makeClickHandler = (handler, eventType) => {
  return e => {
    handler({
      eventType,
      preventDefault: () => e.preventDefault()
    });
  };
};

/**
 * Print and share a url on social in a react component
 */
const SocialShareBar = _ref => {
  let {
    url,
    text,
    showPrint = true,
    showEmail = true,
    showFacebook = true,
    showTwitterX = true,
    onBeforeClick = () => {},
    printLabel,
    emailLabel,
    intl,
    shareLabel = intl.formatMessage(_messages.default.share),
    showAriaLabels = true
  } = _ref;
  const showShare = showFacebook || showTwitterX;
  const showEmailLabel = !showFacebook && !showTwitterX;
  const showPrintLabel = !showFacebook && !showTwitterX;
  return (
    /*#__PURE__*/
    // adding pmc classname fc-gray-2 until we figure out theming
    _react.default.createElement(_style.StyledShareBar, null, showShare ? /*#__PURE__*/_react.default.createElement(_style.StyledLabel, {
      className: "fc-gray-2"
    }, shareLabel) : null, showPrint ? /*#__PURE__*/_react.default.createElement(_print.default, {
      url: url,
      text: text,
      showLabel: showPrintLabel,
      label: printLabel,
      onBeforeClick: makeClickHandler(onBeforeClick, 'print'),
      "aria-label": showAriaLabels ? intl.formatMessage(_messages.default.print) : null
    }) : null, showEmail ? /*#__PURE__*/_react.default.createElement(_email.default, {
      url: url,
      text: text,
      showLabel: showEmailLabel,
      label: emailLabel,
      onBeforeClick: makeClickHandler(onBeforeClick, 'email'),
      "aria-label": showAriaLabels ? intl.formatMessage(_messages.default.email) : null
    }) : null, showFacebook ? /*#__PURE__*/_react.default.createElement(_facebook.default, {
      url: url,
      text: text,
      onBeforeClick: makeClickHandler(onBeforeClick, 'facebook'),
      "aria-label": showAriaLabels ? intl.formatMessage(_messages.default.facebook) : null
    }) : null, showTwitterX ? /*#__PURE__*/_react.default.createElement(_twitterX.default, {
      url: url,
      text: text,
      onBeforeClick: makeClickHandler(onBeforeClick, 'X'),
      "aria-label": showAriaLabels ? intl.formatMessage(_messages.default.twitterX) : null
    }) : null)
  );
};
SocialShareBar.propTypes = {
  /**
   * The url of the page you want to share.
   */
  url: _propTypes.default.string.isRequired,
  /**
   * The text that will form the subject line of the email or the text of the tweet or post.
   */
  text: _propTypes.default.string.isRequired,
  /**
   * Show the print icon
   */
  showPrint: _propTypes.default.bool,
  /**
   * Show the email icon
   */
  showEmail: _propTypes.default.bool,
  /**
   * Show the Facebook icon
   */
  showFacebook: _propTypes.default.bool,
  /**
   * Show the X Icon
   */
  showTwitterX: _propTypes.default.bool,
  /**
   * Called before the the onClick is executed for the link or the button. Called with the type of event ('print', 'facebook' etc.).
   */
  onBeforeClick: _propTypes.default.func,
  /**
   * Override the email label
   */
  emailLabel: _propTypes.default.string,
  /**
   * Override the print label
   */
  printLabel: _propTypes.default.string,
  /**
   * Override the share label
   */
  shareLabel: _propTypes.default.string,
  /**
   * Where or not to show the aria-label attribute on the buttons
   */
  showAriaLabels: _propTypes.default.bool,
  /**
   * The injected intl
   */
  intl: _propTypes.default.object
};
var _default = exports.default = (0, _intl.injectIntl)(SocialShareBar);
SocialShareBar.__docgenInfo = {
  "description": "Print and share a url on social in a react component",
  "methods": [],
  "displayName": "SocialShareBar",
  "props": {
    "showPrint": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Show the print icon",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "showEmail": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Show the email icon",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "showFacebook": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Show the Facebook icon",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "showTwitterX": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Show the X Icon",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onBeforeClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Called before the the onClick is executed for the link or the button. Called with the type of event ('print', 'facebook' etc.).",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "shareLabel": {
      "defaultValue": {
        "value": "intl.formatMessage(messages.share)",
        "computed": true
      },
      "description": "Override the share label",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "showAriaLabels": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Where or not to show the aria-label attribute on the buttons",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "url": {
      "description": "The url of the page you want to share.",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "text": {
      "description": "The text that will form the subject line of the email or the text of the tweet or post.",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "emailLabel": {
      "description": "Override the email label",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "printLabel": {
      "description": "Override the print label",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "intl": {
      "description": "The injected intl",
      "type": {
        "name": "object"
      },
      "required": false
    }
  }
};